import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CREATE_STORE_FORM_ACTION,
  STORE_ACTION_ENUM
} from "@app/features/store-invitation/create-store/create-store.component";
import {CreateStoreService} from "@app/features/store-invitation/create-store.service";

@Component({
  selector: 'app-verify-store-form',
  templateUrl: './verify-store-form.component.html',
  styleUrls: ['./verify-store-form.component.scss']
})
export class VerifyStoreFormComponent implements OnInit {
  @Output() handelAction: EventEmitter<CREATE_STORE_FORM_ACTION> = new EventEmitter<CREATE_STORE_FORM_ACTION>();
  registerForm: any = FormGroup;
  submitted = false;
  passActive = true;
  @Input() data: any;
  public uniqStoreName: boolean = false;

  constructor(private formBuilder: FormBuilder, private storeService: CreateStoreService) {
  }

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      name: [this.data?.storeName ?? '', [Validators.required]],
      password: [this.data?.password ?? '', [Validators.required, Validators.minLength(8)]],
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  public onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid || this.uniqStoreName) {
      return;
    }
    if (this.submitted) {
      const action: CREATE_STORE_FORM_ACTION = {
        selectedIndex: 1,
        data: this.registerForm.getRawValue(),
        action: STORE_ACTION_ENUM.next
      }
      this.handelAction.emit(action)
    }
  }

  public validateStoreName() {
    if (this.f.name.value) {
      this.storeService.validateStoreName(this.f.name.value).subscribe((res: any) => {
        this.uniqStoreName = res;
      }, error => {
        console.log(error);
      })
    }


  }
}

